export const planOptions = [
  {
    name: 'Single Answer Point',
    value: 'singleAnswerPoint',
  },
  {
    name: 'Call Overflow Routing',
    value: 'callOverflowRouting',
  },
  {
    name: 'Call Distribution Routing',
    value: 'callDistributionRouting',
  },
  {
    name: 'VIP Service Routing',
    value: 'vipServiceRouting',
  },
  {
    name: 'State Routing',
    value: 'stateRouting',
  },
  {
    name: 'Business Continuity',
    value: 'businessContinuity',
  },
]

export const states = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'unknown']

export const timeZoneOptions = [
  {
    name: 'ACT',
    value: 'Australia/ACT',
  },
  {
    name: 'Broken Hill',
    value: 'Australia/Broken_Hill',
  },
  {
    name: 'Lorde Howe Island',
    value: 'Australia/LHI',
  },
  {
    name: 'Northern Territory',
    value: 'Australia/North',
  },
  {
    name: 'NSW',
    value: 'Australia/NSW',
  },
  {
    name: 'Queensland',
    value: 'Australia/Queensland',
  },
  {
    name: 'South Australia',
    value: 'Australia/South',
  },
  {
    name: 'Tasmania',
    value: 'Australia/Tasmania',
  },
  {
    name: 'Victoria',
    value: 'Australia/Victoria',
  },
  {
    name: 'Western Australia',
    value: 'Australia/West',
  },
]

export const holidayOptions = [
  {
    name: 'ACT Public Holidays',
    value: 'ACT Public Holidays',
  },
  {
    name: 'NSW Public Holidays',
    value: 'NSW Public Holidays',
  },
  {
    name: 'NT Public Holidays',
    value: 'NT Public Holidays',
  },
  {
    name: 'QLD Public Holidays',
    value: 'QLD Public Holidays',
  },
  {
    name: 'SA Public Holidays',
    value: 'SA Public Holidays',
  },
  {
    name: 'TAS Public Holidays',
    value: 'TAS Public Holidays',
  },
  {
    name: 'VIC Public Holidays',
    value: 'VIC Public Holidays',
  },
  {
    name: 'WA Public Holidays',
    value: 'WA Public Holidays',
  },
]

export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sundary']



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersCallPlanForm/NumbersCallPlanForm.data.js